import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';

// This component renders a simple three-dot menu that opens the context menu (same as right-clicking)
export default class SimpleContextMenuRenderer implements ICellRendererComp {
    private buttonElement: HTMLButtonElement | HTMLDivElement = null;
    private onClick: (e: MouseEvent) => void = null;
    private showText = false;

    refresh(params): boolean {
        this.setCell(params);

        if (params.node.group && !this.showText)
            this.buttonElement.classList.add("d-none");
        else
            this.buttonElement.classList.remove("d-none");
        return true;
    }

    getGui(): HTMLElement {
        return this.buttonElement;
    }

    destroy(): void {
        this.buttonElement.removeEventListener("click", this.onClick);
    }

    init(params: SimpleContextMenuParams): void {
        this.setCell(params);
        this.refresh(params);
    }
    setCell(params: SimpleContextMenuParams) {
        const temp: HTMLDivElement = document.createElement("div");
        const isPipelineConfig = params.isPipelineConfig ?? false;
        if (isPipelineConfig) {// used in pipline config pages
            this.showText = false;
            this.setPMPipelineConfigCellRenderer(params, temp);
        }
        else {
            this.showText = true;
            if (params.data?.GroupData?.groupName === "Totals" || params.data?.ID === "total") {
                this.setRegCellRenderer(params, temp); // for totals row
            }
            else if (params.isCXOne){
                if (!params.node.group && (params.isLeaderboard || (params.groupLevel === 1 && params.groupType === "E"))) {
                    this.setMetricColumnCellRenderer(params, temp);
                } else { // for any table that isnt emp group level 1
                    this.setRegCellRenderer(params, temp);
                }
            } else {
                if (this.shouldShow3DotMenuPM(params)) {
                    this.setMetricColumnCellRenderer(params, temp);
                } else { // Metric cells without objectives
                    this.setRegCellRenderer(params, temp);
                }
            }
        }
    }

    shouldShow3DotMenuPM(params: SimpleContextMenuParams): boolean {
        //In PM metric cells with objectives will have the three-dot menu except the interval breakdown groups.
        return params.value && params.value.objectiveData && params.value.objectiveData.poValueColor
        && (!params.node.group || params.isExpandedSummary);
    }

    setRegCellRenderer(params: SimpleContextMenuParams, temp: HTMLDivElement) {
        temp.innerHTML = `<div> ${params.valueFormatted ?? ''} </div>`;
        this.buttonElement = temp;
    }

    setMetricColumnCellRenderer(params: SimpleContextMenuParams, temp: HTMLDivElement) {
        const classes = 'icon-btn cv-context-menu-icon-hideable float-left fill-moreDark';
        if(params.isLeaderboard) {
            temp.innerHTML = `
                <button type="button" class="${classes}" 
                    style="${params.isCXOne ? 'margin-top: 0.45rem !important; outline:none !important;' : ''}">
                    <svg class="icon-16">
                        <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
                    </svg>
                </button>
                <div> ${params.valueFormatted ?? ''} </div>
            `;
        }
        else { // metric interval, metric summary
            temp.innerHTML = `
                <button type="button" class="${classes} mt-n1">
                    <svg class="icon-12">
                        <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
                    </svg>
                </button>
                <div> ${params.valueFormatted ?? ''} </div>
            `;
        }
        this.buttonElement = temp;
        const button = temp.querySelector("button");
        this.onClick = (e: MouseEvent) => params.api['contextMenuFactory'].showMenu(params.node, params.column, params.value, e);
        button.addEventListener("click", this.onClick);
    }

    setPMPipelineConfigCellRenderer(params: SimpleContextMenuParams, temp: HTMLDivElement) {
        temp = document.createElement("div");
        temp.innerHTML = `
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
                </svg>
            </button>
        `;
        this.buttonElement = temp.querySelector("button");
        this.onClick = (e: MouseEvent) => params.api['contextMenuFactory'].showMenu(params.node, params.column, params.value, e);
        this.buttonElement.addEventListener("click", this.onClick);
    }
}

interface SimpleContextMenuParams extends ICellRendererParams {
    isCXOne: boolean;
    isLeaderboard: boolean;
    groupLevel: number;
    groupType: string;
    isPipelineConfig?: boolean;
    isExpandedSummary?: boolean;
}
